<!--
 * @Author: your name
 * @Date: 2021-01-05 11:14:22
 * @LastEditTime: 2021-01-09 10:48:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\email\index.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">
          服务大厅
        </router-link> &gt; 我的服务
      </div>
    </div>
    <div class="z_title1" style="margin-top: 10px">查询条件</div>
    <div class="searchBody">
      <span>类别：</span>
      <a-select v-model="type" placeholder="全部" style="width: 100px">
        <a-select-option value>全部</a-select-option>
        <a-select-option v-for="(item,index) in categoryList" :key="index" :value="item.id">
          {{ item.name }}
        </a-select-option>
<!--        <a-select-option :value="6">失物招领</a-select-option>-->
      </a-select>
      <span style="margin-left: 10px">标题：</span>
      <a-input style="width: 200px" v-model="name"></a-input>
      <a-button style="margin-left: 5px" @click="getList" type="primary">搜索</a-button>
    </div>
    <div class="itemsList" v-for="(item, index) in list" :key="index">
      <div style="display: flex; align-items: center">
        <img style="margin-right: 5px" src="@/assets/point.jpg" width="4" height="4" alt=""/>
        <a @click="go(item.type === 6? '/lostAndFound/info':  '/replyInfos',item)">
          {{ item.name }}
          ({{ item.type === 6 ? '失物招领' : cateName(item.type) }})
        </a>
      </div>
      <div align="left" class="STYLE1">
        <span v-if="item.type!==2" style="margin-right: 30px">
          {{
            item.status === 0 ? "未受理" : item.status === 1 ? '已受理' : item.status === 2 ? '已完成' : item.status === 3 ? "已转交" : item.status === 4 ? "不受理" : ''
          }}
        </span>
        <span v-else style="margin-right: 30px">
          {{ item.status === 1? "寻找中" : "失主已找到，宝贝已回家" }}
        </span>
        {{ item.gmtCreate }}
      </div>
    </div>
    <a-pagination
        @change="pageChange"
        :current="current"
        style="margin-top: 10px"
        size="small"
        :total="total"
        :pageSize="pageSize"
    />
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      list: [],
      categoryList: [],
      total: 1,
      current: 1,
      pageSize: 15,
      type: undefined,
      name: ''
    };
  },
  created() {
    // this.$forceUpdate();
    this.getCategoryList();
    this.getList();
  },
  methods: {
    getCategoryList() {
      postAction("/user/appeal/category/categoryList").then((data) => {
        this.categoryList = data.data.list;
      });
    },
    cateName(type) {
      let a = ''
      this.categoryList.forEach((item) => {
        if (type === item.id) a = item.name
      })
      return a
    },
    go(path, item) {
      let url = ''
      if (item.type === 6) {
        url = '/user/lost/details'
      } else {
        url = '/user/appeal/appeal/getDetails'
      }
      getAction(url, {id: item.id, type:'1'}).then((data) => {
        if (data.code === 0) {
          this.$router.push({
            path: path,
            query: {
              record: encodeURIComponent(JSON.stringify(Object.assign(data.data, {isMe: 1}))),
            }
          })
        } else {
          this.$message.error(data.message)
        }
      })

    },
    pageChange(page) {
      this.current = page;
      this.getList();
    },
    getList() {
      postAction("/user/appeal/myAppeal", {
        pageSize: this.pageSize,
        pageNum: this.current,
        type: this.type,
        name: this.name,
      }).then((data) => {
        this.list = data.data.list;
        this.total = data.data.total;
      });
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.searchBody {
  padding: 10px;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}
</style>
